export default "__VITE_ASSET__0cbfb2a6__"